// Exact color palettes matching the Python implementation
// Blues for vertical walls, Reds for roof types
export const LOAD_AREA_TYPE_COLORS: Record<WindLoadAreaType, string> = {
  // Vertical Wall Wind Load Area Types (Blues palette)
  Wall_A: '#d6e6f5', // (0.8406920415224913, 0.9016378316032295, 0.9586620530565167)
  Wall_B: '#abd0e6', // (0.6718954248366014, 0.8143790849673203, 0.9006535947712418)
  Wall_C: '#6a9fd4', // (0.41708573625528644, 0.6806305267204922, 0.8382314494425221)
  Wall_D: '#3787c0', // (0.21568627450980393, 0.5294117647058824, 0.7542483660130719)
  Wall_E: '#105ba4', // (0.06251441753171857, 0.35750865051903113, 0.6429065743944637)

  // Gable Roof Wind Load Area Types (Reds palette)
  Gable_F: '#fdd4c2', // (0.9935870818915802, 0.8323414071510957, 0.7624913494809689)
  Gable_G: '#fc9f82', // (0.9882352941176471, 0.6261437908496732, 0.5084967320261438)
  Gable_H: '#fb6949', // (0.9835755478662053, 0.4127950788158401, 0.28835063437139563)
  Gable_I: '#e32f27', // (0.8901960784313725, 0.18562091503267975, 0.15294117647058825)
  Gable_J: '#b11218', // (0.6943944636678201, 0.07003460207612457, 0.09231833910034601)

  // Hip Roof Wind Load Area Types (Reds palette)
  Hip_F: '#fee4d6', // (0.9969242599000384, 0.8961937716262975, 0.8489042675893886)
  Hip_G: '#fdc9b5', // (0.9913725490196079, 0.7913725490196079, 0.7082352941176471)
  Hip_H: '#fcab8f', // (0.9882352941176471, 0.6715417147251057, 0.5605382545174933)
  Hip_I: '#fc8a6a', // (0.9874509803921568, 0.5411764705882353, 0.41568627450980394)
  Hip_J: '#fb6949', // (0.9835755478662053, 0.4127950788158401, 0.28835063437139563)
  Hip_K: '#f24432', // (0.9466666666666667, 0.26823529411764707, 0.19607843137254902)
  Hip_L: '#d92422', // (0.8503344867358708, 0.14686658977316416, 0.13633217993079583)
  Hip_M: '#bc1429', // (0.7364705882352941, 0.08, 0.10117647058823528)
  Hip_N: '#980c13', // (0.5946174548250673, 0.04613610149942329, 0.07558631295655516)

  // Shed Roof Wind Load Area Types (Reds palette)
  Shed_F: '#fdd9cc', // (0.9950634371395617, 0.8596539792387543, 0.7986620530565167)
  Shed_FLow: '#fcaf93', // (0.9882352941176471, 0.6866743560169165, 0.5778854286812765)
  Shed_FHigh: '#fc8161', // (0.9865897731641676, 0.5067281814686659, 0.38123798539023457)
  Shed_G: '#f44e38', // (0.9570011534025374, 0.3087120338331411, 0.22191464821222606)
  Shed_H: '#d62222', // (0.8370472895040368, 0.13394848135332565, 0.13079584775086506)
  Shed_I: '#aa1016', // (0.6663437139561708, 0.06339100346020761, 0.08641291810841982)

  // Flat Roof Wind Load Area Types (Reds palette)
  Flat_F: '#fdc9b5', // (0.9913725490196079, 0.7913725490196079, 0.7082352941176471)
  Flat_G: '#fc8a6a', // (0.9874509803921568, 0.5411764705882353, 0.41568627450980394)
  Flat_H: '#f24432', // (0.9466666666666667, 0.26823529411764707, 0.19607843137254902)
  Flat_I: '#bc1429', // (0.7364705882352941, 0.08, 0.10117647058823528)
}

// Helper function to get color for a wind load area type
export const getWindLoadAreaTypeColor = (loadAreaType: WindLoadAreaType): string => {
  return LOAD_AREA_TYPE_COLORS[loadAreaType] || '#FFA07A' // Default fallback color
}
